// Auth context for dispatch system
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('dispatch_token', token);
  } else {
    localStorage.removeItem('dispatch_token');
  }
};

export const getAuthToken = () => {
  return localStorage.getItem('dispatch_token');
};

export const setUser = (user) => {
  localStorage.setItem('dispatch_user', JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem('dispatch_user');
  return user ? JSON.parse(user) : null;
};

export const logout = () => {
  localStorage.removeItem('dispatch_token');
  localStorage.removeItem('dispatch_user');
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
